<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 18 18">
  <g clip-path="url(#a)">
    <path d="m17.25 9-1.83-2.085.255-2.76-2.708-.615-1.417-2.385L9 2.25 6.45 1.155 5.032 3.54l-2.707.607.255 2.76L.75 9l1.83 2.085-.255 2.767 2.707.615 1.418 2.385L9 15.75l2.55 1.095 1.417-2.385 2.708-.615-.255-2.76L17.25 9Zm-7.5 3.75h-1.5v-1.5h1.5v1.5Zm0-3h-1.5v-4.5h1.5v4.5Z"/>
  </g>
  <defs>
    <clipPath id="a">
      <path d="M0 0h18v18H0z"/>
    </clipPath>
  </defs>
</svg>
